import { get } from 'lodash';

const getSwc = (state, path, defaultValue) =>
  get(state.adom?.fortiswitch, path, defaultValue);

export const devScope = (state) => getSwc(state, 'devScope', []);
